<template>
	<div class="body-container">
		<headerNavigation :isHome="true" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="page-content-container">
			<div class="page-home-container">
				<div class="banner-homepage-region">
				    <div class="comp-banner-home-container sms-wgt-banner home-banner">
				        <div class="image-container">
							<img :src="bannerImg" v-if="!isMobile">
							<img :src="bannerMobileImg" v-else>
				        </div>
				        <div class="content-container">
				            <div class="content-title">
				                <h1 class="header">{{$t('common.customonlineprinting')}}</h1>
				                <div class="description">{{$t('common.displaygoodtaste')}}</div>
				            </div>
				            <div class="content-btn-container">
				                <div class="content-btn">
				                    <a class="cta-button site-btn-primary">{{$t('common.shopnow')}}</a>
				                </div>
				            </div>
				        </div>
				    </div>
				</div>
				<div class="css-grid-container css-grid">
					<div class="css-grid-span-6 hidden-mobile leftnav-container scroll-lazy lazy-loaded" v-if="!isMobile">
						<div class="global-left-nav-container">
							<div class="leftnav-title">{{$t('common.popularproducts')}}</div>
							<div class="list-wrapper ga4-nav-click left-nav">
								<div class="nav-item" :class="index == categoryList.length - 1 ? 'border-bottom' : ''" v-for="(item,index) in categoryList" :key="index">
								    <a href="javascript:void(0)" @click="openPage('/category?no='+item.pid+'&level=2')">
										<img :src="item.img" class="lazy-loaded">
								        <div class="catalog-name">{{item.typeName}}</div>
										<img src="../../assets/images/right.png" class="right-icon"/>
								    </a>
								</div>
								<div class="nav-item" style="margin-top: 10px;">
								    <a href="javascript:void(0)" @click="openPage('/article?no=15')">
										<div class="catalog-name">{{$t('common.directmail')}}</div>
								    </a>
								</div>
								<div class="nav-item">
								    <a href="javascript:void(0)" @click="openPage('/designService')">
										<div class="catalog-name">{{$t('common.designservice')}}</div>
								    </a>
								</div>
								<div class="nav-item all-products highlight" >
								    <a href="javascript:void(0)" @click="openPage('/quotes')">
										<div class="catalog-name">{{$t('common.customquote')}}</div>
										<img src="../../assets/images/right.png" class="right-icon"/>
								    </a>
								</div>
								<!-- <div class="nav-item all-products highlight">
								    <a href="javascript:void(0)" @click="openPage('/category')">
										<div class="catalog-name">{{$t('common.seemoreproducts')}}</div>
										<img src="../../assets/images/right.png" class="right-icon"/>
								    </a>
								</div> -->
							</div>
						</div>
					</div>
					<div class="regions-container js-regions-container " :class="isMobile ? 'is-mobile-device' : ''">
						<div class="product-homepage-region">
							<div class="catalog-type-portcat" v-if="hotlist.length > 0">
								<div class="wgt-catalog-title">
								    <h2>{{$t('common.topsellers')}}</h2>
								</div>
								<div class="wgt-catalog-group-container js-portcat-carousel owl-theme owl-carousel owl-loaded owl-drag">
									<div class="owl-nav js-portcat-carousel-detached owl-nav-left">
										<button ref="owlPrev1" class="owl-prev disabled" type="button" @click="swiperPrev(hotlist,1,232,4)">
											<img src="../../assets/images/left.png" class="left-icon"/>
										</button>
									</div>
									<div class="owl-stage-outer" ref="owllist1">
										<template v-if="isMobile">
											<div ref="owlbox1" data-startX="0" data-currentX="0" data-translateX="0" @touchstart="handleTouchStart(1, $event)" @touchmove="handleTouchMove(1, $event,141.33,3)" @touchend="handleTouchEnd(1, $event)" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all;">
												<div class="owl-item" v-for="(item,index) in hotlist" :key="index">
													<div class="comp-portrait-catalog-item-container wgt-catalog-item-container scroll-lazy accessibility-item">
														<div class="wgt-catalog-outline">
												            <a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
										</template>
										<template v-else>
											<div ref="owlbox1" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all;">
												<div class="owl-item" v-for="(item,index) in hotlist" :key="index">
													<div class="comp-portrait-catalog-item-container wgt-catalog-item-container scroll-lazy accessibility-item">
														<div class="wgt-catalog-outline">
												            <a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																	<div class="wgt-catalog-item-button">
																		<div class="hover-btn site-btn-primary">{{$t('common.shopnow')}}</div>
																	</div>
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
										</template>
									</div>
									<div class="owl-nav" v-if="!isMobile">
										<button ref="owlNext1" class="owl-next" type="button" @click="swiperNext(hotlist,1,232,4)">
											<img src="../../assets/images/right.png" class="left-icon"/>
										</button>
									</div>
								</div>
							</div>
							<div class="catalog-type-portcat" v-if="tslist.length > 0">
								<div class="wgt-catalog-title">
								    <h2>{{$t('common.featuredproducts')}}</h2>
								</div>
								<div class="wgt-catalog-group-container js-portcat-carousel owl-theme owl-carousel owl-loaded owl-drag">
									<div class="owl-nav js-portcat-carousel-detached owl-nav-left">
										<button ref="owlPrev2" class="owl-prev disabled" type="button" @click="swiperPrev(tslist,2,232,4)">
											<img src="../../assets/images/left.png" class="left-icon"/>
										</button>
									</div>
									<div class="owl-stage-outer" ref="owllist2">
										<template v-if="isMobile">
											<div ref="owlbox2" data-startX="0" data-currentX="0" data-translateX="0" @touchstart="handleTouchStart(2, $event)" @touchmove="handleTouchMove(2, $event,141.33,3)" @touchend="handleTouchEnd(2, $event)" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all;">
												<div class="owl-item" v-for="(item,index) in tslist" :key="index">
													<div class="comp-portrait-catalog-item-container wgt-catalog-item-container scroll-lazy accessibility-item">
														<div class="wgt-catalog-outline">
												            <a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
										</template>
										<template v-else>
											<div ref="owlbox2" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all;">
												<div class="owl-item" v-for="(item,index) in tslist" :key="index">
													<div class="comp-portrait-catalog-item-container wgt-catalog-item-container scroll-lazy accessibility-item">
														<div class="wgt-catalog-outline">
												            <a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon" />
																	<div class="wgt-catalog-item-button">
																		<div class="hover-btn site-btn-primary">{{$t('common.shopnow')}}</div>
																	</div>
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
										</template>
									</div>
									<div class="owl-nav" v-if="!isMobile">
										<button ref="owlNext2" class="owl-next" type="button" @click="swiperNext(tslist,2,232,4)">
											<img src="../../assets/images/right.png" class="left-icon"/>
										</button>
									</div>
								</div>
							</div>
							<div class="catalog-type-portcat" v-if="newlist.length > 0">
								<div class="wgt-catalog-title">
								    <h2>{{$t('common.newupdatedproducts')}}</h2>
								</div>
								<div class="wgt-catalog-group-container js-portcat-carousel owl-theme owl-carousel owl-loaded owl-drag">
									<div class="owl-nav js-portcat-carousel-detached owl-nav-left">
										<button ref="owlPrev3" class="owl-prev disabled" type="button" @click="swiperPrev(newlist,3,232,4)">
											<img src="../../assets/images/left.png" class="left-icon"/>
										</button>
									</div>
									<div class="owl-stage-outer" ref="owllist3">
										<template v-if="isMobile">
											<div ref="owlbox3" data-startX="0" data-currentX="0" data-translateX="0" @touchstart="handleTouchStart(3, $event)" @touchmove="handleTouchMove(3, $event,141.33,3)" @touchend="handleTouchEnd(3, $event)" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all;">
												<div class="owl-item" v-for="(item,index) in newlist" :key="index">
													<div class="comp-portrait-catalog-item-container wgt-catalog-item-container scroll-lazy accessibility-item">
														<div class="wgt-catalog-outline">
												            <a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
										</template>
										<template v-else>
											<div ref="owlbox3" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all;">
												<div class="owl-item" v-for="(item,index) in newlist" :key="index">
													<div class="comp-portrait-catalog-item-container wgt-catalog-item-container scroll-lazy accessibility-item">
														<div class="wgt-catalog-outline">
												            <a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																	<div class="wgt-catalog-item-button">
																		<div class="hover-btn site-btn-primary">{{$t('common.shopnow')}}</div>
																	</div>
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
										</template>
									</div>
									<div class="owl-nav" v-if="!isMobile">
										<button ref="owlNext3" class="owl-next" type="button" @click="swiperNext(newlist,3,232,4)">
											<img src="../../assets/images/right.png" class="left-icon"/>
										</button>
									</div>
								</div>
							</div>
							<div class="catalog-type-landcat" v-if="yhlist.length > 0">
								<div class="wgt-catalog-title">
								    <h2>{{$t('common.bestdeals')}}</h2>
								</div>
								<div class="wgt-catalog-group-container js-landcat-carousel owl-theme owl-carousel scroll-lazy  owl-drag ">
									<div class="owl-nav js-portcat-carousel-detached owl-nav-left">
										<button ref="owlPrev4" class="owl-prev disabled" type="button" @click="swiperPrev(yhlist,4,464,2)">
											<img src="../../assets/images/left.png" class="left-icon"/>
										</button>
									</div>
									<div class="owl-stage-outer" ref="owllist4">
										<template v-if="isMobile">
											<div ref="owlbox4" data-startX="0" data-currentX="0" data-translateX="0" @touchstart="handleTouchStart(4, $event)" @touchmove="handleTouchMove(4, $event,424,1)" @touchend="handleTouchEnd(4, $event)" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: 0.25s;">
												<div class="owl-item" v-for="(item,index) in yhlist" :key="index">
													<div class="comp-landscape-catalog-item-container wgt-catalog-item-container accessibility-item">
														<div class="wgt-catalog-outline">
													        <a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																	<div class="wgt-catalog-item-text">
																		<ul>
																			<li style="color: #333;" v-for="(tag,tindex) in item.featureTags">{{tag}}</li>
																		</ul>
																	</div>
																</div>
															</a>
													    </div>
													</div>
												</div>
											</div>
										</template>
										<template v-else>
											<div ref="owlbox4" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: 0.25s;">
												<div class="owl-item" v-for="(item,index) in yhlist" :key="index">
													<div class="comp-landscape-catalog-item-container wgt-catalog-item-container accessibility-item">
														<div class="wgt-catalog-outline">
													        <a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																	<div class="wgt-catalog-item-button">
																		<button class="site-btn-primary">{{$t('common.shopnow')}}</button>
																	</div>
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																	<ul>
																		<li style="color: #333;" v-for="(tag,tindex) in item.featureTags">{{tag}}</li>
																	</ul>
																</div>
															</a>
													    </div>
													</div>
												</div>
											</div>
										</template>
									</div>
									<div class="owl-nav" v-if="!isMobile">
										<button ref="owlNext4" class="owl-next" type="button" @click="swiperNext(yhlist,4,464,2)">
											<img src="../../assets/images/right.png" class="left-icon"/>
										</button>
									</div>
								</div>
							</div>
						</div>
						<div class="service-homepage-region">
							<div class="sms-wgt-list-carousel list-carousel-type-imgslide accessibility">
								<div class="wgt-list-carousel-title">
									<h2>{{$t('common.trustedonlinechoice')}}</h2>
								</div>
								<div class="wgt-list-carousel-group-container list-carou-imgslide js-imgslide-carousel owl-theme owl-carousel scroll-lazy owl-loaded owl-drag">
									<template v-if="isMobile">
										<div class="comp-imgslide-list-carousel-item-container wgt-list-carousel-item-container accessibility-item" v-for="(item,index) in partnerList" :key="index">
										    <div class="wgt-list-carousel-item-image">
												<img :src="item">
											</div>
										</div>
									</template>
									<template v-else>
										<div class="owl-nav js-imgslide-carousel-detached owl-nav-left">
											<button type="button" ref="owlPrev5" class="owl-prev disabled" @click="swiperPrev(partnerList,5,190,5)">
												<img src="../../assets/images/left.png" class="left-icon"/>
											</button>
										</div>
										<div class="owl-stage-outer" ref="owllist5">
											<div class="owl-stage" ref="owlbox5" style="transform: translate3d(0px, 0px, 0px); transition: all; width: 1710px;">
												<div class="owl-item" style=" margin-right: 30px;" v-for="(item,index) in partnerList" :key="index">
													<div class="comp-imgslide-list-carousel-item-container wgt-list-carousel-item-container accessibility-item">
										            	<div class="wgt-list-carousel-item-image">
															<img class="img-responsive owlImg" :src="item">
														</div>
														<div class="wgt-list-carousel-item-desc-container">
															<div class="wgt-list-carousel-item-title"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="owl-nav">
											<button type="button" ref="owlNext5" class="owl-next" @click="swiperNext(partnerList,5,190,5)">
												<img src="../../assets/images/right.png" class="left-icon"/>
											</button>
										</div>
									</template>
							    </div>
							</div>
							<div class="sms-wgt-html " v-if="videourl">
								<div id="video-div">
									<div class="vid-section">
										<div class="video-container">
											<div class="video-copy">{{$t('common.qualityprecisionexperience')}}</div>
											<div class="color-overlay-one"></div>
											<video autoplay="" loop="" muted="">
												<source :src="videourl" type="video/mp4">
											</video>
										</div>
									</div>
								</div>
								<div class="thirtythree-blue">
									<div class="row" style="display:block;overflow:hidden;">
										<div class="thirty-logo">
											<img src="../../assets/images/brilliantly-white-img.png" class="img-responsive thirtythree-logo" loading="lazy">
										</div>
										<div class="thirty-separator">
											<img src="../../assets/images/diagonaline.png" class="img-responsive diagonaline" loading="lazy">
										</div>
										<div class="thirty-slogan">
											<div class="head-QPE">{{$t('common.33checkpoints')}}</div>
										</div>
										<div class="thirty-cta">
											<a class="cta-button site-btn-primary thirtythree-cta" style="max-width: 300px;">{{$t('common.learnmore')}}</a>
										</div>
									</div>
								</div>
							</div>
							<div class="sms-wgt-list list-type-3colcath ">
								<div class="wgt-list-title">
									<h2>{{$t('customerTrust.headertitle')}}</h2>
								</div>
								<div class="wgt-list-description">{{$t('customerTrust.headertxt')}}</div>
								<div class="comp-3col-catalog-list-item-container wgt-list-group-container scroll-lazy">
									<div class="wgt-list-item-container" v-for="(item,index) in qualityList" :key="index">
										<div class="wgt-list-outline">
											<div class="wgt-list-item-image">
												<img class="img-responsive" :src="item.img">
											</div>
											<div class="wgt-list-item-desc-container">
												<div class="wgt-list-item-title">{{item.title}}</div>
												<div class="wgt-list-item-description">{{item.desc}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="sms-wgt-list-carousel list-carousel-type-testi accessibility">
								<div class="wgt-list-carousel-title">
									<h2>{{$t('common.commentheader')}}</h2>
								</div>
								<div class="wgt-list-carousel-subtitle">
									{{$t('common.commenttxt')}}
								</div>
								<div class="wgt-list-carousel-group-container js-testi-carousel owl-theme owl-carousel scroll-lazy hover-lazy owl-loaded owl-drag">
									<div class="owl-stage-outer" ref="owllist7">
										<template v-if="isMobile">
											<div ref="owlbox7" data-startX="0" data-currentX="0" data-translateX="0" @touchstart="handleTouchStart(7, $event)" @touchmove="handleTouchMove(7, $event,436,1)" @touchend="handleTouchEnd(7, $event)" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: 0.25s;">
												<div class="owl-item" v-for="(item,index) in commentList">
													<div class="comp-testi-list-carousel-item-container wgt-list-carousel-item-container star-rating accessibility-item">
														<div class="wgt-list-outline">
															<div class="wgt-list-heading">
																<div class="wgt-list-carousel-item-image ">
																	<img class="img-responsive" :src="item.img">
																</div>
																<div class="wgt-list-carousel-item-title">
																	<div class="wgt-list-item-title">{{item.author}}</div>
																	<div class="wgt-list-item-subtitle">{{item.title}}<br>{{item.createTime}}</div>
																	<div class="wgt-list-carousel-item-addon-styles rating">
																		<img src="../../assets/images/star2.png" class="star-icon" v-for="star in Number(item.fraction)"/>
																		<img src="../../assets/images/star1.png" class="star-icon" v-if="Number(item.fraction) < 5" v-for="star in (5 - Number(item.fraction))" />
																	</div>
																</div>
															</div>
															<div class="wgt-list-item-description">{{item.content}}</div>
														</div>
													</div>
												</div>
											</div>
										</template>
										<template v-else>
											<div class="owl-stage">
												<div class="owl-item" style="width: 274.667px;" v-for="(item,index) in commentList.slice(0,3)">
													<div class="comp-testi-list-carousel-item-container wgt-list-carousel-item-container star-rating accessibility-item">
														<div class="wgt-list-outline">
															<div class="wgt-list-heading">
																<div class="wgt-list-carousel-item-image ">
																	<img class="img-responsive" :src="item.img">
																</div>
																<div class="wgt-list-carousel-item-title">
																	<div class="wgt-list-item-title">{{item.author}}</div>
																	<div class="wgt-list-item-subtitle">{{item.title}}<br>{{item.createTime}}</div>
																	<div class="wgt-list-carousel-item-addon-styles rating">
																		<img src="../../assets/images/star2.png" class="star-icon" v-for="star in Number(item.fraction)"/>
																		<img src="../../assets/images/star1.png" class="star-icon" v-if="Number(item.fraction) < 5" v-for="star in (5 - Number(item.fraction))" />
																	</div>
																</div>
															</div>
															<div class="wgt-list-item-description">{{item.content}}</div>
														</div>
													</div>
												</div>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>
						<div class="category-homepage-region">
							<div class="sms-wgt-text-image scroll-lazy">
							    <div class="wgt-text-title">
							        <h2>{{$t('common.browsebycategory')}}</h2>
								</div>
							</div>
							<ul class="wgt-catalog-nav-tabs">
							    <li class="wgt-catalog-nav-tab-item" :class="categoryIndex == index ? 'active' : ''" v-for="(item,index) in categoryFirst" :key="index" @click="changeCategoty(index)">
							        <a class="nav-tab-item-link click-lazy">{{item.typeName}}</a>
							    </li>
							    <hr class="nav-helper">
							</ul>
							<div class="catalog-warp">
							    <div class="sms-wgt-catalog catalog-type-cattabs tab-pane fade hover-lazy accessibility active in">
									<div class="wgt-catalog-group-container js-cattabs-carousel owl-theme owl-carousel owl-loaded owl-drag">
										<div class="owl-nav js-cattabs-carousel-detached owl-nav-left">
											<button type="button" ref="owlPrev6" class="owl-prev disabled" @click="swiperPrev(productList,6,234,4)">
												<img src="../../assets/images/left.png" class="left-icon"/>
											</button>
										</div>
							            <div class="owl-stage-outer" ref="owllist6">
											<template v-if="isMobile">
												<div class="owl-stage" ref="owlbox6" data-startX="0" data-currentX="0" data-translateX="0" @touchstart="handleTouchStart(6, $event)" @touchmove="handleTouchMove(6, $event,226,2)" @touchend="handleTouchEnd(6, $event)" style="transform: translate3d(0px, 0px, 0px); transition: all; width: 3978px;">
													<div class="owl-item" style="width: 216px;" v-for="(item,index) in productList" :key="index">
														<div class="comp-cattabs-catalog-item-container wgt-catalog-item-container scroll-lazy accessibility-item">
															<a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																</div>
															</a>
														</div>
													</div>
												</div>
											</template>
											<template v-else>
												<div class="owl-stage" ref="owlbox6" style="transform: translate3d(0px, 0px, 0px); transition: all; width: 3978px;">
													<div class="owl-item" v-for="(item,index) in productList" :key="index">
														<div class="comp-cattabs-catalog-item-container wgt-catalog-item-container scroll-lazy accessibility-item">
															<a href="javascript:void(0)" @click="openPage('/product?no='+item.product_no)">
																<div class="wgt-catalog-item-image">
																	<img class="img-responsive owlImg" :src="item.icon">
																</div>
																<div class="wgt-catalog-item-desc-container">
																	<div class="wgt-catalog-item-title">{{item.productname}}</div>
																</div>
															</a>
														</div>
													</div>
												</div>
											</template>
										</div>
										<div class="owl-nav" v-if="!isMobile">
											<button type="button" class="owl-next" ref="owlNext6" @click="swiperNext(productList,6,234,4)">
												<img src="../../assets/images/right.png" class="left-icon"/>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- <div class="article-homepage-region">
							<div class="sms-wgt-catalog catalog-type-thumbnail-image scroll-lazy hover-lazy">
								<div class="wgt-catalog-title">
								    <h2>探索 UPrinting 博客上的新内容</h2>
									<div class="custom-hr"></div>
								</div>
								<div class="wgt-catalog-group-container js-3colcatv-carousel owl-theme owl-carousel owl-loaded owl-drag">
									<div class="owl-stage-outer" ref="owllist8">
										<template v-if="isMobile">
											<div class="owl-stage" ref="owlbox8" data-startX="0" data-currentX="0" data-translateX="0" @touchstart="handleTouchStart(8, $event)" @touchmove="handleTouchMove(8, $event,432,1)" @touchend="handleTouchEnd(8, $event)" style="transform: translate3d(0px, 0px, 0px); transition: all;">
												<div class="owl-item" style="width: 432px;" v-for="item in 3">
													<div class="comp-3colcatv-catalog-item-container wgt-catalog-item-container">
												        <a class="wgt-catalog-item-link">
												            <div class="wgt-catalog-item-image">
												                <img class="img-responsive owlImg" src="../../assets/test/UP_Raised-Emboss-Postcard_E2.png">
												            </div>
												            <div class="wgt-catalog-item-desc-container">
												                <div class="wgt-catalog-item-title">2025年明信片营销最大化：65个必知统计数据</div>
												            </div>
														</a>
												    </div>
												</div>
											</div>
										</template>
										<template v-else>
											<div class="owl-stage">
												<div class="owl-item" style="width: 312px;" v-for="item in 3">
													<div class="comp-3colcatv-catalog-item-container wgt-catalog-item-container">
												        <a class="wgt-catalog-item-link">
												            <div class="wgt-catalog-item-image">
												                <img class="img-responsive owlImg" src="../../assets/test/UP_Raised-Emboss-Postcard_E2.png">
												            </div>
												            <div class="wgt-catalog-item-desc-container">
												                <div class="wgt-catalog-item-title">2025年明信片营销最大化：65个必知统计数据</div>
												            </div>
														</a>
												    </div>
												</div>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loginModal from '../../components/loginModal.vue'
	import loading from '../../components/loading.vue'
	import {initHome,initHomeProduct,brandList} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			loginModal,
			loading
		},
		data() {
			return {
				productList:[],
				partnerList:[],
				qualityList:[
					{
						img:require('../../assets/test/free-artwork.svg'),
						title:this.$t('customerTrust.title1'),
						desc:this.$t('customerTrust.remark1'),
					},
					{
						img:require('../../assets/test/Custom Product Builder.svg'),
						title:this.$t('customerTrust.title2'),
						desc:this.$t('customerTrust.remark2'),
					},
					{
						img:require('../../assets/test/reliable.svg'),
						title:this.$t('customerTrust.title3'),
						desc:this.$t('customerTrust.remark3'),
					}
				],
				commentList:[],
				isMobile:false,
				isDragging:false,
				showLoginModal:false,
				isLoading:false,
				categoryList:[],
				bannerImg:'',
				bannerMobileImg:'',
				hotlist:[],
				newlist:[],
				tslist:[],
				yhlist:[],
				videourl:'',
				categoryFirst:[],
				categoryIndex:''
			};
		},
		mounted() {
			
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.init()
			this.initHomeProduct()
			this.getBrand()
		},
		methods: {
			init(){
				var that = this;
				let params = {}
				this.isLoading = true
				initHome(params).then(res => {
					that.isLoading = false
					if (res.code == 200) {
						that.bannerImg = res.data.img
						that.bannerMobileImg = res.data.mimg
						that.categoryList = res.data.categorysecond
						that.categoryFirst = res.data.categorylist
						that.categoryIndex = 0
						if(that.categoryFirst.length > 0){
							that.productList = that.categoryFirst[0].subclassVOList
							that.$nextTick(() => {
								if(that.isMobile){
									that.calculateSwiper(that.productList,6,216,2,'owllist6')
								}else{
									that.calculateSwiper(that.productList,6,234,4,'owllist6')
								}
							})
						}
						
					}
				})
			},
			initHomeProduct(){
				var that = this;
				let params = {}
				initHomeProduct(params).then(res => {
					if (res.code == 200) {
						that.hotlist = res.data.hotlist
						that.newlist = res.data.newlist
						that.tslist = res.data.tslist
						that.yhlist = res.data.yhlist
						that.$nextTick(() => {
							if(that.isMobile){
								if(that.hotlist.length > 0){
									that.calculateSwiper(that.hotlist,1,141.33,3,'owllist1')
								}
								if(that.tslist.length > 0){
									that.calculateSwiper(that.tslist,2,141.33,3,'owllist2')
								}
								if(that.newlist.length > 0){
									that.calculateSwiper(that.newlist,3,141.33,3,'owllist3')
								}
								if(that.yhlist.length > 0){
									that.calculateSwiper(that.yhlist,4,424,1,'owllist4')
								}
							}else{
								if(that.hotlist.length > 0){
									that.calculateSwiper(that.hotlist,1,232,4,'owllist1')
								}
								if(that.tslist.length > 0){
									that.calculateSwiper(that.tslist,2,232,4,'owllist2')
								}
								if(that.newlist.length > 0){
									that.calculateSwiper(that.newlist,3,232,4,'owllist3')
								}
								if(that.yhlist.length > 0){
									that.calculateSwiper(that.yhlist,4,464,2,'owllist4')
								}
							}
						})
					}
				})
			},
			getBrand(){
				var that = this;
				let params = {}
				brandList(params).then(res => {
					if (res.code == 200) {
						that.partnerList = res.data.list
						that.videourl = res.data.videourl
						that.commentList = res.data.evaluationItems
						
						that.$nextTick(() => {
							if(that.isMobile){
								that.calculateSwiper(that.commentList,7,436,1,'owllist7')
							}else{
								if(that.partnerList.length > 0){
									that.calculateSwiper(that.partnerList,5,160,5)
								}
							}
						})
					}
				})
			},
			openLoginMadal(){
				this.showLoginModal = true
				this.changeRegister(false)
			},
			closeLoinMadal(){
				this.showLoginModal = false
			},
			calculateSwiper(arr,index,width,minNum,boxName=''){
				if(boxName){
					width = this.calculateItemWidth(boxName,minNum)
				}
				var outbox = this.$refs[`owlbox${index}`]
				const owlItems = outbox.querySelectorAll('.owl-item');
				owlItems.forEach(item => {
				    item.style.width = `${width}px`;
				});
				var boxwidth = arr.length * width
				if(index == 5){
					boxwidth = boxwidth + (arr.length * 30)
				}
				outbox.style = `width:${boxwidth}px;transform: translate3d(0px, 0px, 0px); transition: all;`
				if(!this.isMobile){
					if(arr.length <= minNum){
						var btnRef = this.$refs[`owlNext${index}`]
						btnRef.className = 'owl-next disabled';
					}else{
						var btnRef = this.$refs[`owlNext${index}`]
						btnRef.className = 'owl-next';
					}
				}
			},
			swiperPrev(arr,index,width,minNum){
				var that = this
				if(arr.length > minNum){
					var outbox = this.$refs[`owlbox${index}`]
					var boxwidth = arr.length * width
					outbox.style = `width:${boxwidth}px;translate3d(0px, 0px, 0px); transition: 1s;`
					var btnRef = this.$refs[`owlNext${index}`]
					btnRef.className = 'owl-next ';
					var btnPrevRef = this.$refs[`owlPrev${index}`]
					btnPrevRef.className = 'owl-prev disabled';
				}
			},
			swiperNext(arr,index,width,minNum){
				var that = this
				if(arr.length > minNum){
					var outbox = this.$refs[`owlbox${index}`]
					var boxwidth = arr.length * width
					outbox.style = `width:${boxwidth}px;transform: translate3d(-928px, 0px, 0px); transition: 1s;`
					var btnRef = this.$refs[`owlNext${index}`]
					btnRef.className = 'owl-next disabled';
					var btnPrevRef = this.$refs[`owlPrev${index}`]
					btnPrevRef.className = 'owl-prev';
				}
			},
			handleTouchStart(catIndex, e) {
			    this.isDragging = true;
				var outbox = this.$refs[`owlbox${catIndex}`]
				outbox.setAttribute('data-startX', e.touches[0].clientX);
				outbox.setAttribute('data-currentX', outbox.getAttribute('data-translateX'));
			},
			handleTouchMove(catIndex, e ,itemWidth,num) {
			    if (!this.isDragging) return;
				
				var outbox = this.$refs[`owlbox${catIndex}`]
				const boxwidth = outbox.offsetWidth;
				
				const currentX = e.touches[0].clientX;
				const diffX = currentX - Number(outbox.getAttribute('data-startX'));
				
				const newTranslateX = Number(outbox.getAttribute('data-currentX')) + diffX;
				
				const minTranslate = -(boxwidth - (itemWidth * num)); 
				
				if (newTranslateX > 0 || newTranslateX < minTranslate) {
				    
				} else {
					if(newTranslateX >= -20){
						outbox.setAttribute('data-translateX', 0);
						outbox.style = `width:${boxwidth}px;transform: translate3d(0px, 0px, 0px); transition: 0.25s;`
					}else{
						outbox.setAttribute('data-translateX', newTranslateX);
						outbox.style = `width:${boxwidth}px;transform: translate3d(${newTranslateX}px, 0px, 0px); transition: 0.25s;`
					}
					
				}
			},
			handleTouchEnd(catIndex, e) {
			    if (!this.isDragging) return;
			    this.isDragging = false;
			},
			calculateItemWidth(boxName,num){
				var outbox = this.$refs[`${boxName}`]
				const boxwidth = outbox.offsetWidth;
				var width = Math.ceil(boxwidth / num) 
				return width;
			},
			changeRegister(e){
				this.$refs.loginRef.changeRegisterType(e)
				this.showLoginModal = true
			},
			changeCategoty(index){
				this.categoryIndex = index
				this.productList = this.categoryFirst[index].subclassVOList
				this.$nextTick(() => {
					if(this.isMobile){
						this.calculateSwiper(this.productList,6,216,2,'owllist6')
					}else{
						this.calculateSwiper(this.productList,6,234,4)
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/index.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>